(ns frontend.ui.component.label.style)

(defn label
  []
  {:display        "block"
   :font-weight    "bold"
   :padding-bottom "8px"})

(defn form-label
  []
  ^{:extend label}
  {})

